import { A3Link } from '../model/a3-link';
export class A3LinkBuilder {
    static buildA3Link(data) {
        let a3Link = new A3Link();
        a3Link.id = data.id;
        a3Link.creation_date = data.creation_date;
        a3Link.status = data.status;
        return a3Link;
    }
}
//# sourceMappingURL=a3-link-builder.js.map